export default function reducer(state = {
    isAuthenticated: false,
    email: "",
    displaySuccessMessage: false,
    userRegSucess: false,
    displaySuccessMessage: false,
    loading : false,
    userUpdated:false,
    showPopUp:false,
    boschId:"",
    
}, action) {

    switch (action.type) {

        case "AUTH_SUCCESS":
            {
                return {
                    ...state,
                    isAuthenticated: true


                }
            }
        case "AUTH_SUCCESS_CIAM":
            {
                
                return {
                    ...state,
                    email: action.payload.email,
                    boschId:action.payload.sub


                }
            }
        case "AUTH_SUCCESS_AZURE":
                {
                    
                    return {
                        ...state,
                        email: action.payload.email,
                        boschId:action.payload.oid
    
    
                    }
                }
        case "USER_REG_SUCCESS":
            {
                return {
                    ...state,
                    displaySuccessMessage: true,
                    userRegSucess: true,
                    loading: true
                }
            }
        case "USER_REG_FAIL":
            {
                return {
                    ...state,
                    displayErrorMessage: true,
                    //userRegSucess: false
                }
            }
        case "USER_REG_FAIL_IBE":
            {
                return {
                    ...state,
                    ibeMessage: "Email with Bosch domain is not allow login with SingleKeyID. Please login again with Bosch account.",
                    displayErrorMessage: true,
                    
                    //userRegSucess: false
                }
            }
        case "LOG_OUT":
            {
                return {
                    ...state,
                    isAuthenticated: false


                }
            }
        case "RESET_CLOSE":
            {
                return {
                    ...state,
                    displaySuccessMessage: false,
                    displayErrorMessage: false


                }
            }
        case "RESET_SUCCESS_CLOSE":
            {
                return {
                    ...state,
                    displaySuccessMessage: false



                }
            }
        case "RESET_ERROR_CLOSE":
            {
                return {
                    ...state,
                    displayErrorMessage: false



                }
            }

        case "API_LOADING": {
            return { ...state, loading: true };
        }
        case "STOP_API_LOADING" :{
            return {...state, loading : false};
            }

            case "USER_UPD_FAIL":
            {
                return {
                    ...state,
                    userUpdated:false,
                }
            }
            case "USER_UPD_SUCCESS":
                {
                    return {
                        ...state,
                        userUpdated:true,
                        displayRegPopUp:false,
                        emailID: email ,
                        showNotice:false,
                        isuserAgreed: true,
                         show: false
                       
                    }
                }
                case "USERAGREED_SUCC":
                    {
                        return {
                            ...state,
                            showPopUp:false,
                           
                        }
                    }
                    case "USERAGREED_FAIL":
                        {
                            return {
                                ...state,
                                showPopUp:true,
                               
                            }
                        }
    }
    return state
}